module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-211.6e365d23.svg";